import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function MultipleSelectChip({ 
  label = 'Select',
  options = [],
  value = [],
  onChange,
  width = 300,
  placeholder = 'Select items',
  disabled = false,
  fullWidth = false,
  showSelectAll = true
}) {
  const getOptionValue = (option) => {
    return typeof option === 'string' ? option : option.value || option.id;
  };

  const getOptionLabel = (option) => {
    return typeof option === 'string' ? option : option.label || option.name || option.value;
  };

  // Calculate selection states
  const allSelected = options.length > 0 && value.length === options.length;
  const someSelected = value.length > 0 && !allSelected;

  return (
    <FormControl 
      sx={{ m: 1, width: fullWidth ? '100%' : width }} 
      fullWidth={fullWidth}
      disabled={disabled}
      className="sites-select-chip"
      variant="outlined"
    >
      <InputLabel id="multiple-chip-label" variant="outlined">{label}</InputLabel>
      <Select
        labelId="multiple-chip-label"
        id="multiple-chip-select"
        multiple
        value={value}
        onChange={() => {}} 
        label={label}
        MenuProps={MenuProps}
        variant="outlined"
        renderValue={(selected) => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {selected.length === 0 ? (
              <em style={{ color: '#999' }}>{placeholder}</em>
            ) : (
              <>
                {selected.slice(0, 3).map((val) => {
                  const option = options.find(opt => getOptionValue(opt) === val);
                  return (
                    <Chip 
                      key={val} 
                      label={option ? getOptionLabel(option) : val} 
                      size="small"
                    />
                  );
                })}
                {selected.length > 3 && (
                  <Chip
                    key="additional-count"
                    label={`...+${selected.length - 3}`}
                    size="small"
                  />
                )}
              </>
            )}
          </Box>
        )}
      >
        {options.length === 0 ? (
          <MenuItem disabled>
            <em>No options available</em>
          </MenuItem>
        ) : (
          <>
            {showSelectAll && (
              <MenuItem 
                value="select-all"
                onClick={(e) => {
                  e.stopPropagation();
                  const newValue = allSelected ? [] : options.map(getOptionValue);
                  onChange(newValue);
                }}
              >
                <Checkbox 
                  checked={allSelected}
                  indeterminate={someSelected}
                />
                <ListItemText primary="Select All" />
              </MenuItem>
            )}
            {options.map((option) => {
              const optionValue = getOptionValue(option);
              const optionLabel = getOptionLabel(option);
              const isSelected = value.includes(optionValue);
              return (
                <MenuItem 
                  key={optionValue} 
                  value={optionValue}
                  onClick={(e) => {
                    e.stopPropagation();
                    const newValue = isSelected
                      ? value.filter(v => v !== optionValue)
                      : [...value, optionValue];
                    onChange(newValue);
                  }}
                >
                  <Checkbox checked={isSelected} />
                  <ListItemText primary={optionLabel} />
                </MenuItem>
              );
            })}
          </>
        )}
      </Select>
    </FormControl>
  );
}

